module.exports = __webpack_public_path__ + "img/doc.e14ed2c5.svg";